/**
 * Parcels Receipt
 */

// React
import React, { useEffect, useState } from 'react';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { WrapperReceipt } from './style';
import jMoment from 'moment-jalaali';

// Helper
import { formaterPhoneNumber, translate } from '../../utils/helpers';

// Type
import { Props } from './interfaces';
import ordersRepository from "client-sdk/src/Repository/orders-repository";

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
    },
  })
);

export function Details(props: Props) {
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState({});
  const [error, setError] = useState("");
  const classes = useStyles();
  const orderWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await ordersRepository.getOrderWithId({ payload });
      setOrder(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);

    }
  };
  useEffect(() => {
    const { id } = props.match.params;
    orderWithId(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // useEffect(() => {
  //   const {id} = props.match.params;
  //   props.getOrderWithIdActionDispatch(id);
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (order.id) {
      window.print();
    }
  }, [order])

  return (
    <WrapperReceipt className={classes.root}>
      <div className="page">
        <div className="logo-box">
          <div>
            <img src="/logo-dark.svg" alt="logo" />
          </div>
        </div>

        <div className=" wrapper ">
          {/*Section 1 */}
          <div
            className="flex"
            style={{
              marginBottom: '15px',
            }}
          >
            <div className="flex flex-column flex-1 ">
              <div className="title">رسید حواله سفارش</div>
              <div className="flex justify-content-between">
                <div className="flex">
                  <span className="label"> تاریخ ثبت:</span>
                  <span className="bold">
                    {' '}
                    {order.registrationDate &&
                      `${jMoment(order.registrationDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
                <div className="flex">
                  <span className="label"> تاریخ تحویل:</span>
                  <span className="bold">
                    {' '}
                    {order.deliveryDate &&
                      `${jMoment(order.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </div>
              </div>
            </div>
            <div className="flex-1" />
          </div>

          {/* Section 2 */}
          <div className="card-a">
            <div className="card-a_box">
              <div className="card-a_item">
                <div className="card-a_label"> نام سفارش دهنده </div>
                <div className="card-a_text"> {order.customerName}</div>
              </div>
              <div className="card-a_item">
                <div className="card-a_label"> شماره همراه سفارش دهنده </div>
                <div className="card-a_text">
                  {formaterPhoneNumber(order?.customerPhoneNumber)}
                </div>
              </div>
              <div className="card-a_item">
                <div className="card-a_label"> بازه تحویل سفارش </div>
                <div className="card-a_text">
                  {' '}
                  {order.deliveryStartTime &&
                    jMoment(order.deliveryStartTime, 'hh:mm:ss')
                      .locale('fa')
                      .format('HH:mm')}
                  {' - '}
                  {order.deliveryEndTime &&
                    jMoment(order.deliveryEndTime, 'hh:mm:ss')
                      .locale('fa')
                      .format('HH:mm')}{' '}
                </div>
              </div>
              <div className="card-a_item">
                <div className="card-a_label"> وضعیت تحویل </div>
                <div className="card-a_text">
                  {' '}
                  {translate(order.status, 'order')}{' '}
                </div>
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="card-a">
            <div className="card-a_box">

              <div className="card-a_item">
                <div className="card-a_label"> آدرس سفارش دهنده </div>
                <div className="card-a_text">
                  {order.customerAddress && order.customerAddress}{' '}
                </div>
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="title" style={{ marginTop: '15px' }}>
            محتویات سفارش
          </div>

          <div className="card-b">
            <div className="card-b_box">
              <div className="card-b_header-box">
                <div className="card-b_header">
                  <div className="card-b_header-item">ردیف</div>
                  <div className="card-b_header-item">نام محصول</div>
                  <div className="card-b_header-item">شناسه محصول</div>
                  <div className="card-b_header-item">تعداد</div>
                  {/* <div className="card-b_header-item">تعدادکارتن</div> */}
                  {/* <div className="card-b_header-item">نوع کارتن</div> */}
                  <div className="card-b_header-item">توضیحات</div>
                </div>
              </div>
              <div className="card-b_content">
                {order?.items?.map((item: any, index: number) => {
                  return (
                    <div className="card-b_content-row">
                      <div className="card-b_content-item">{index + 1}</div>
                      <div className="card-b_content-item">
                        {item.productName}
                      </div>
                      <div className="card-b_content-item">{item.skuId}</div>
                      <div className="card-b_content-item">{item.count}</div>
                      <div className="card-b_content-item">{ }</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Section 4 */}
          <div className="title" style={{ marginTop: '15px' }}>
            توضیحات
          </div>

          <div className="description" />

          {/* Section Last */}
          <div className="sing-box">
            <div className="item">
              <span>امضا تحویل دهنده</span>
              <span>:تاریخ</span>
            </div>
            <div className="item">
              <span>امضا راننده</span>
              <span>:تاریخ</span>
            </div>
            <div className="item">
              <span>امضا تحویل گیرنده</span>
              <span>:تاریخ</span>
            </div>
          </div>
        </div>
      </div>
    </WrapperReceipt>
  );
}


export default Details;
